
import { mapMutations, mapActions } from "vuex";
import Pagination from './Pagination';
import { openUrl } from '~/plugins/util'
export default {
  components: { Pagination },
  props: {
    sideTypes: {
      type: Array,
      default: () => []
    },
    hotTitle: "",
    sideList: {
      type: Array,
      default: () => {}
    },
    pageInfo: { type: Object, default: () => {}},
    loading: { type: Boolean, default: false}
  },
  data() {
    return {
      show: true,
      type: 3,
      current: 0,
    };
  },
  computed: {
    hotNumber(index) {
      return (index) => {
        return (this.pageInfo.page - 1) * this.pageInfo.page_size + index + 1;
        }
    }
  },
  watch: {
  },
  mounted() {
    this.type = this.$route.query.type || 3;
    this.init();
  },
  methods: {
    ...mapMutations("map", ["setMapInfoObj"]),
    ...mapMutations("player", ["updateVr"]),
    ...mapActions("player", ["play"]),

    // 打开音频
    openAudio(audio) {
      this.play(audio);
    },
    // 打开vr链接
    openVr(vr) {
      this.updateVr(vr);
    },

    init() {
      switch (parseInt(this.type)) {
        case 1: //景点
          this.current = 1;
          break;
        case 2: //故事
          this.current = 2;
          break;
        case 3: //人物
          this.current = 0;
          break;
      }
    },

    changeSide(item, i) {
      if (this.current == i) return;
      this.current = i;
      this.type = this.sideTypes[i].type;
      this.setMapInfoObj({ type: this.type });
    },

    changePage(page) {
      this.$emit('changePage', page);
    },

    /** 详情 */
    toDetail(item, i) {
      if (!item.name && !item.title) return;

      openUrl(this.$router, {
        path: '/map/detail',
        query: { name: item.name || item.title, type: this.type }
      })
    }
  }
};
